import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "../../layout/AppLayout";
import { ErpSelect, ErpTable, toOptions, today } from "../../components/erp";
import { errorText } from "../../api/client";
import { bookingApi, BookingListRow, usePurchaseDropdowns } from "./api";

/** Port of v3/Purchase/rm-booking-list.php (+ includes/page-filter.php: PsId, BookingDate, ArrivalPlant) */
export default function BookingList() {
  const dd = usePurchaseDropdowns();
  const [psId, setPsId] = useState("");
  const [date, setDate] = useState(today());
  const [plant, setPlant] = useState("");
  const [q, setQ] = useState<{ date: string; psId: string } | null>(null);
  const list = useQuery({
    queryKey: ["purchase", "bookings", q],
    queryFn: () => bookingApi.list(q!.date, q!.psId),
    enabled: !!q,
  });
  const rows = list.data?.Data || [];
  return (
    <>
      <PageHeader title="Booking List" location="Purchase" />
      <div className="row rowFilter"><div className="col-md-12"><div className="card"><div className="card-body">
        <div className="row">
          <div className="col col-md-3 mb-3"><ErpSelect id="drpPurchaseList" placeholder="Select Purchase" value={psId} onChange={setPsId} options={toOptions(dd.data?.PurchaseCenters, (r) => r.PurchaseStationID, (r) => r.StationName)} /></div>
          <div className="col col-md-3 mb-3"><ErpSelect id="drpArrivalPlant" placeholder="Select Arrival Plant" value={plant} onChange={setPlant} options={toOptions(dd.data?.ProcessingStations, (r) => r.ProcessingStationID, (r) => r.StationName)} /></div>
          <div className="col col-md-3 mb-3"><input type="date" className="form-control" id="txtBookingDate" max={today()} value={date} onChange={(e) => setDate(e.target.value)} data-testid="filter-booking-date" /></div>
          <div className="col col-md-3 mb-3"><button type="button" id="btnSearch" className="btn btn-primary" style={{ minWidth: 150 }} onClick={() => setQ({ date, psId })} data-testid="btn-search">Search</button></div>
        </div>
      </div></div></div></div>
      <div className="row"><div className="col-12"><div className="card"><div className="card-body">
        <div className="text-center mb-3"><Link to="/v3/Purchase/create-booking" className="btn btn-success waves-effect waves-light" data-testid="btn-new-booking"><i className="fa fa-plus" />  New Bookings</Link></div>
        <ErpTable<BookingListRow> rows={rows} loading={list.isLoading} error={list.isError ? errorText(list.error) : list.data?.Error || null} testId="booking-list-table"
          columns={[
            { key: "SNO", title: "S.No" }, { key: "Species", title: "Species" }, { key: "BookingNumber", title: "Booking Number " }, { key: "BookingDate", title: "Booking Date" },
            { key: "PurchaseType", title: "PurchaseType" }, { key: "Grader", title: "Grader" }, { key: "Agent", title: "Agent" }, { key: "BookingCount", title: "Booking Count" },
            { key: "BookingWeight", title: "Booking Weight" }, { key: "BookingRate", title: "Booking Rate" },
            { key: "act", title: "Actions", render: (r) => <Link to={`/v3/Purchase/create-booking?BookingID=${r.BookingID}`} className="mr-3 text-primary" title="Edit Booking" data-testid={`edit-booking-${r.BookingID}`}><i className="mdi mdi-pencil font-size-18" /></Link> },
          ]} />
      </div></div></div></div>
    </>
  );
}
